<div class="w-100 h-100 d-flex flex-column gap-3 px-0 px-md-4 px-lg-5 py-2 step-body-scroll">
  <div class="text-center w-100">
    <div class="shadow-lg rounded-4 overflow-hidden w-100 px-lg-5 py-2"
      style="backdrop-filter: blur(10px); background: rgba(255,255,255,0.8);">
      <div class="container-fluid">
        <div class="container text-center">
          <form [formGroup]="editForm">
            <div class="d-flex align-items-center justify-content-between gap-4 my-3 w-100">

              <div class="justify-content-start align-items-center">
                <div
                  style="width: 100px; height: 100px; background-color: #008A70; border-radius: 50%; display: inline-block; background-image: url('data:image/png;base64,{{ userDetails?.displayImageBytes }}'); background-size: cover; background-position: center;"
                  aria-label="User profile image">
                  <div style="position: relative; width: 100px; height: 100px;">
                    <span *ngIf="!userDetails?.displayImageBytes"
                      style="color: black; font-size: 2.5em; line-height: 100px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">{{
                      dataService.initials }}</span>
                  </div>
                </div>
              </div>

              <div class="d-flex flex-column gap-1 align-items-start w-100">
                <h5 style="color: #000000;font-weight: 500;font-size: 24px;" class="m-0">{{ fullName }} <span style=" background-color:#E7F6EF;color:#2BB673;font-size:12px;font-weight:600;padding:4px 10px;border-radius:20px;">
                    {{roleLabel}}
                  </span></h5>
                <p style="color:#898989;font-size: 16px;font-weight: 400;" class="m-0">&commat;{{ userId }}</p>
              </div>

              <div class="d-flex justify-content-end">
                <button type="button"
                  style="background: black;border-radius: 8px;padding: 12px 16px; border:none;font-size: 14px;font-weight: 500;color:#ffffff;"
                  (click)="save()" [disabled]="editForm.invalid || isSubmitting">
                  <div class="loading-spinner" *ngIf="isSubmitting"></div>
                  {{ isSubmitting ? 'Saving...' : 'Save' }}
                </button>
              </div>
            </div>

            <h6 class="section-title">Personal</h6>
            <div class="row mb-3">
              <div class="col-md-6">
                <label for="firstName" class="form-label required-field text-start customeLabelTextForEditProfile">First
                  Name</label>
                <div class="form-floating">
                  <input type="text" class="form-control custom-input" id="firstName" formControlName="firstName"
                    placeholder="First Name">
                  <button type="button"
                    class="btn btn-sm btn-light position-absolute top-50 end-0 translate-middle-y me-2 rounded-circle clear-btn"
                     *ngIf="editForm.get('firstName')?.value?.length > 1" (click)="editForm.get('firstName')?.setValue('')"
                    aria-label="Clear first name">
                    <i class="fa-solid fa-x"></i></button>
                  <div class="invalid-feedback"
                    *ngIf="editForm.get('firstName')?.errors?.['required'] && editForm.get('firstName')?.touched">
                    First name is required
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <label for="lastName" class="form-label required-field text-start customeLabelTextForEditProfile">Last
                  Name</label>
                <div class="form-floating">
                  <input type="text" class="form-control custom-input" id="lastName" formControlName="lastName"
                    placeholder="Last Name">
                  <button type="button"
                    class="btn btn-sm btn-light position-absolute top-50 end-0 translate-middle-y me-2 rounded-circle clear-btn"
                    *ngIf="editForm.get('lastName')?.value?.length > 1 " (click)="editForm.get('lastName')?.setValue('')"
                    aria-label="Clear first name">
                    <i class="fa-solid fa-x"></i></button>
                  <div class="invalid-feedback"
                    *ngIf="editForm.get('lastName')?.errors?.['required'] && editForm.get('lastName')?.touched">
                    Last name is required
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-6">
                <label for="emailId" class="form-label required-field text-start customeLabelTextForEditProfile">Email
                  Address</label>
                <div class="form-floating">
                  <input type="email" class="form-control custom-input" id="emailId" formControlName="emailId"
                    placeholder="Email">
                  <button type="button"
                    class="btn btn-sm btn-light position-absolute top-50 end-0 translate-middle-y me-2 rounded-circle clear-btn"
                     *ngIf="editForm.get('emailId')?.valid" (click)="editForm.get('emailId')?.setValue('')"
                    aria-label="Clear first name">
                    <i class="fa-solid fa-x"></i></button>
                  <div class="invalid-feedback"
                    *ngIf="editForm.get('emailId')?.errors?.['required'] && editForm.get('emailId')?.touched">
                    Email is required
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <label for="timeZone" class="form-label required-field text-start customeLabelTextForEditProfile">User
                  TimeZone</label>
                <mat-form-field appearance="outline" class="w-100 custom-mat-field">
                  <mat-select formControlName="timeZone">
                    <mat-option *ngFor="let timeZone of timeZones" [value]="timeZone.code">
                      {{ timeZone.display }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

            </div>
            <div class="row mb-3">
              <div class="col-md-6">
                <label class="form-label required-field  text-start customeLabelTextForEditProfile">
                 Language
                </label>
                 <mat-form-field appearance="outline" class="w-100 custom-mat-field">
                 <mat-select formControlName="prefLangCd" placeholder="Select Language">
                 <mat-option value="en">English</mat-option>
                 <mat-option value="de">German</mat-option>
                 </mat-select>
                </mat-form-field>

              </div>

              <div class="col-md-6">
                <label class="form-label required-field text-start customeLabelTextForEditProfile invisible-label">
                   Language Level
                </label>
                <div class="d-flex align-items-center gap-2">
                  <mat-form-field appearance="outline" class="flex-grow-1 custom-mat-field">
                    <mat-select formControlName="prefLangLevel" placeholder="Select Level">
                      <mat-option value="fluent">Fluent</mat-option>
                      <mat-option value="basic">Basic</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <button type="button" class="btn btn-sm btn-light rounded-circle clear-btn"  (click)="editForm.get('prefLangLevel')?.reset()"
                    aria-label="Clear first name">
                    <i class="fa-solid fa-minus"></i></button>
                     <!-- <button type="button" class="btn btn-sm btn-light rounded-circle clear-btn"
                 *ngIf="editForm.get('prefLangLevel')?.value"
                   (click)="editForm.get('prefLangLevel')?.setValue(null)"
                    aria-label="Clear first name">
                    <i class="fa-solid fa-minus"></i></button> -->
                </div>
              </div>
            </div>


            <div class="row mb-3">
              <button type="button"
                style="background: black;border-radius: 8px;padding: 12px 16px; border:none;font-size: 14px;font-weight: 500;color:#ffffff;">Add
                Language</button>
            </div>
            <!-- <h6 class="section-title mb-1">Professional</h6>
            <div class="row mb-3">
              <div class="col-md-4">
                <label for="experience" class="form-label required-field text-start customeLabelTextForEditProfile" >Experience</label>
                <div class="form-floating">
                  <input type="text" class="form-control custom-input" id="experience" formControlName="experience"
                    placeholder="Experience">
                  <div class="invalid-feedback"
                    *ngIf="editForm.get('experience')?.errors?.['required'] && editForm.get('experience')?.touched">
                    Experience is required
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <label class="form-label required-field text-start customeLabelTextForEditProfile">Software</label>
                <div class="d-flex flex-wrap gap-2 align-items-center">
                  <div *ngFor="let item of software">
                    <mat-checkbox [value]="item" (change)="onCheckboxChange($event)" [checked]="isChecked(item)">
                      {{ item }}
                    </mat-checkbox>
                  </div>
                  <mat-checkbox value="Other" (change)="onCheckboxChange($event)" [checked]="isChecked('Other')">
                    Other
                  </mat-checkbox>
                  <input type="text" class="form-control custom-input" id="otherSoftware"
                    formControlName="otherSoftware" placeholder="Other Software" [disabled]="!showOtherInput"
                    style="max-width: 300px; flex: 1;">
                </div>
                <mat-error *ngIf="editForm.get('software')?.errors?.['required'] && editForm.get('software')?.touched">
                  Please select at least one software
                </mat-error>
              </div>
            </div>

            <div class="col-12 mb-3">
              <label for="emailId" class="form-label required-field text-start customeLabelTextForEditProfile">Professional
                Skills</label>
              <mat-form-field appearance="outline" class="w-100 custom-mat-field">
                <mat-select formControlName="primarySkill" multiple>
                  <mat-option *ngFor="let skill of skills" [value]="skill">{{ skill }}</mat-option>
                </mat-select>
                <mat-error
                  *ngIf="editForm.get('primarySkill')?.errors?.['required'] && editForm.get('primarySkill')?.touched">
                  Please select at least one skill
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-12 mb-3">
              <label for="additionalSkill" class="form-label text-start customeLabelTextForEditProfile">Additional
                Skills</label>
              <div class="form-floating">
                <textarea class="form-control custom-input" id="additionalSkill" formControlName="additionalSkill"
                  placeholder="Additional Skills" style="height: 70px"></textarea>
              </div>
            </div> -->

            <div class="col-12 mb-3">
              <label for="about" class="form-label text-start customeLabelTextForEditProfile">About Me</label>
              <div class="form-floating">
                <textarea class="form-control custom-input" id="about" formControlName="about" placeholder="About Me"
                  style="height: 100px"></textarea>
              </div>
            </div>

            <div *ngIf="dataService.role !== 'doctor'">
              <div class="col d-flex gap-4">
                <div>
                  Upload portfolio images for public showcase
                </div>
                <div>
                  <div (click)="customFile.click()">
                    <i class="fa fa-upload" style="color: #205567; cursor:pointer;"></i>
                    <input hidden multiple (change)="onUploadImages($event)" #customFile type="file" id="customFile"
                      multiple>
                  </div>
                </div>
              </div>

              <div class="portfolio-images-list flex-wrap gap-3">
                <div *ngFor="let image of portfolioImages;" class="portfolio-image-item"
                  style="text-align: left; height: 20px;">
                  <span style="vertical-align: super;" class="d-flex gap-2">
                    - <a href="javascript:void(0)" (click)="previewImage(image)"
                      style="color: #205567; text-decoration: underline;">{{ image }}</a>
                    <div style="color: #205567; cursor: pointer;" (click)="removeImage(image)">
                      <i class="fa fa-trash" style="color:#205567;"></i>
                    </div>
                  </span>
                </div>
              </div>
            </div>

            <div class="d-flex  justify-content-center">
              <div class="d-flex justify-content-center gap-3 mt-3">
                <button type="button" class="btn btn-outline-secondary rounded-pill"
                  (click)="onCancel()">Cancel</button>

              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>